export const TextareaTheme = {
    paragraph   : 'editor-paragraph',
    heading     : {
        h1: 'editor-heading-h1',
        h2: 'editor-heading-h2',
        h3: 'editor-heading-h3',
        h4: 'editor-heading-h4',
        h5: 'editor-heading-h5',
        h6: 'editor-heading-h6',
    },
    text        : {
        bold                    : 'editor-textBold',
        code                    : 'editor-textCode',
        italic                  : 'editor-textItalic',
        strikethrough           : 'editor-textStrikethrough',
        subscript               : 'editor-textSubscript',
        superscript             : 'editor-textSuperscript',
        underline               : 'editor-textUnderline',
        underlineStrikethrough  : 'editor-textUnderlineStrikethrough',
    },
    list        : {
        nested              : {
            listitem: 'editor-nested-listitem',
        },
        olDepth: [
            'editor-list-ol1',
            'editor-list-ol2',
            'editor-list-ol3',
            'editor-list-ol4',
            'editor-list-ol5',
        ],
        ol                  : 'editor-list-ol',
        ul                  : 'editor-list-ul',
        listitem            : 'editor-listItem',
        listitemChecked     : 'editor-listItemChecked',
        listitemUnchecked   : 'editor-listItemUnchecked',
    },
    link        : 'editor-link',
    banner      : 'editor-banner',
    quote       : 'editor-quote',

    code        : 'editor-code',
    codeHighlight: {
        atrule      : 'editor-tokenAttr',
        attr        : 'editor-tokenAttr',
        boolean     : 'editor-tokenProperty',
        builtin     : 'editor-tokenSelector',
        cdata       : 'editor-tokenComment',
        char        : 'editor-tokenSelector',
        class       : 'editor-tokenFunction',
        'class-name': 'editor-tokenFunction',
        comment     : 'editor-tokenComment',
        constant    : 'editor-tokenProperty',
        deleted     : 'editor-tokenProperty',
        doctype     : 'editor-tokenComment',
        entity      : 'editor-tokenOperator',
        function    : 'editor-tokenFunction',
        important   : 'editor-tokenVariable',
        inserted    : 'editor-tokenSelector',
        keyword     : 'editor-tokenAttr',
        namespace   : 'editor-tokenVariable',
        number      : 'editor-tokenProperty',
        operator    : 'editor-tokenOperator',
        prolog      : 'editor-tokenComment',
        property    : 'editor-tokenProperty',
        punctuation : 'editor-tokenPunctuation',
        regex       : 'editor-tokenVariable',
        selector    : 'editor-tokenSelector',
        string      : 'editor-tokenSelector',
        symbol      : 'editor-tokenProperty',
        tag         : 'editor-tokenProperty',
        url         : 'editor-tokenOperator',
        variable    : 'editor-tokenVariable',
    },

    image       : 'editor-image',
    attachment  : 'editor-attachment',
    mention     : 'editor-mention',
    badge       : 'editor-badge',
    'font-color': 'editor-font-color',
    indent      : 'editor-indent', // tab spacing

    table                           : 'editor-table',
    tableNodeDOM                    : 'editor-table-node',
    tableAddColumns                 : 'editor-tableAddColumns',
    tableAddRows                    : 'editor-tableAddRows',
    tableCell                       : 'editor-tableCell',
    tableCellActionButton           : 'editor-tableCellActionButton',
    tableCellActionButtonContainer  : 'editor-tableCellActionButtonContainer',
    tableCellEditing                : 'editor-tableCellEditing',
    tableCellHeader                 : 'editor-tableCellHeader',
    tableCellPrimarySelected        : 'editor-tableCellPrimarySelected',
    tableCellResizer                : 'editor-tableCellResizer',
    tableCellSelected               : 'editor-tableCellSelected',
    tableCellSortedIndicator        : 'editor-tableCellSortedIndicator',
    tableResizeRuler                : 'editor-tableCellResizeRuler',
    tableSelected                   : 'editor-tableSelected',
    tableSelection                  : 'editor-tableSelection',

    layoutContainer : 'editor-layoutContainer',
    layoutItem      : 'editor-layoutItem',

    'collapse-container': 'editor-collapse-container',
    'collapse-content'  : 'editor-collapse-content',
    'collapse-title'    : 'editor-collapse-title',

    embedBlock: {
        base    : 'editor-embed-block',
        focus   : 'editor-embed-block-focus',
    },
}